import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Page, Column, Row } from '@oliasoft-open-source/react-ui-library';
import { updateNumberOfCharts } from 'src/store/entities/ui/simulations/chart-controls';
import translations from 'src/internationalisation/translation-map.json';
import { withErrorBoundary } from '@oliasoft-open-source/react-ui-library';
import { ResultChartGrid } from './result-chart-grid';
import { ResultOverviewDrawer } from './drawer/result-overview.drawer';
import './style.less';

const ResultOverview = ({ updateNumberOfCharts, isPageDisabled }) => {
  const { t } = useTranslation();
  useEffect(() => {
    updateNumberOfCharts(2);
  }, [updateNumberOfCharts]);

  return (
    <Page padding={false} scroll={false}>
      <Row spacing={0} flex>
        <ResultOverviewDrawer />
        <Column scroll>
          <div className="results-wrapper">
            <ResultChartGrid
              header={t(translations.simulations_resultOverview)}
              isPageDisabled={isPageDisabled}
              simulateButtons
              showResultHeader
            />
          </div>
        </Column>
      </Row>
    </Page>
  );
};

const mapDispatchToProps = {
  updateNumberOfCharts,
};

export default withErrorBoundary(connect(null, mapDispatchToProps)(ResultOverview), { isPage: true });
